import React from 'react'
import Mic from "../../../assets/Icons/mic.svg";
import MicMute from "../../../assets/Icons/mic-mute.svg";
import Camera from "../../../assets/Icons/camera.svg";
import CameraOff from "../../../assets/Icons/camera-off.svg";

export default function Participants({ streams, me, localStream, isMuted, isVideoTrack, isGroupCall, isVideoCall, muteStream, unmuteStream, turnOnVideo, turnOffVideo, maximizeUserVideo }) {
  return (
    <div id="users-list">
      <div className="userinfo participant d-flex justify-content-between align-items-center border rounded p-2 mb-2 shadow-sm bg-white" key={me._id}>
        <div className="d-flex flex-start cursor-pointer" onClick={() => maximizeUserVideo(localStream, me)}>
          {me?.imageSrc && me?.imageSrc != "" ? (
            <div className="me-3 ms-0">
              <img
                src={me?.imageSrc}
                className="rounded-circle avatar-xs"
                alt="chatvia"
              />
            </div>
          ) : (
            <div className="chat-user-img align-self-center me-3">
              <div className="avatar-xs">
                <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                  {me?.contactName?.first?.charAt(0)}
                </span>
              </div>
            </div>
          )}
          <span
            className="font-semibold cursor-pointer"
            style={{ marginTop: "5px" }}
          >
            You
          </span>
        </div>
        <div className="participants-controls">
          {isMuted ? (
            <img
              src={MicMute}
              alt="mic-mute"
              onClick={unmuteStream}
              className="cursor-pointer"
            />
          ) : (
            <img
              src={Mic}
              alt="mic"
              onClick={muteStream}
              className="cursor-pointer"
            />
          )}
          {!isGroupCall && (!isVideoTrack ? (
            <img
              src={CameraOff}
              alt="camera-off"
              onClick={turnOnVideo}
              className="cursor-pointer"
            />
          ) : (
            <img
              src={Camera}
              alt="camera"
              onClick={turnOffVideo}
              className="cursor-pointer"
            />
          ))}
          {isGroupCall && isVideoCall && (!isVideoTrack ? (
            <img
              src={CameraOff}
              alt="camera-off"
              onClick={turnOnVideo}
              className="cursor-pointer"
            />
          ) : (
            <img
              src={Camera}
              alt="camera"
              onClick={turnOffVideo}
              className="cursor-pointer"
            />
          ))}
        </div>
      </div>
      {streams.map((obj) => {
        const { user } = obj;
        return (
          <div
            className="userinfo participant cursor-pointer"
            key={user._id}
            onClick={() => maximizeUserVideo(obj.stream, user)}
          >
            <div className="flex flex-start">
              {user?.imageSrc && user?.imageSrc != "" ? (
                <div className="me-3 ms-0">
                  <img
                    src={user?.imageSrc}
                    className="rounded-circle avatar-xs"
                    alt="chatvia"
                  />
                </div>
              ) : (
                <div className="chat-user-img align-self-center me-3">
                  <div className="avatar-xs">
                    <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                      {user?.contactName?.first?.charAt(0)}
                    </span>
                  </div>
                </div>
              )}
              <span
                className="font-semibold cursor-pointer"
                style={{ marginTop: "5px" }}
              >
                {user?.contactName?.first + " " + user?.contactName?.last}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  )
}
